import React from 'react';
import { ScheduleStatus } from '../../types/schedule';
import Badge from '../common/Badge';

interface ScheduleStatusBadgeProps {
  status: ScheduleStatus;
}

const ScheduleStatusBadge: React.FC<ScheduleStatusBadgeProps> = ({ status }) => {
  const getVariant = () => {
    switch (status) {
      case 'draft':
        return 'secondary';
      case 'preferences_open':
        return 'info';
      case 'preferences_closed':
        return 'warning';
      case 'published':
        return 'success';
      default:
        return 'secondary';
    }
  };

  const getLabel = () => {
    switch (status) {
      case 'draft':
        return 'Draft';
      case 'preferences_open':
        return 'Preferences Open';
      case 'preferences_closed':
        return 'Preferences Closed';
      case 'published':
        return 'Published';
      default:
        return 'Unknown';
    }
  };

  return (
    <Badge variant={getVariant()} rounded>{getLabel()}</Badge>
  );
};

export default ScheduleStatusBadge; 